import { render, staticRenderFns } from "./UgTabItem.vue?vue&type=template&id=e1fc3eaa&scoped=true"
import script from "./UgTabItem.vue?vue&type=script&lang=ts"
export * from "./UgTabItem.vue?vue&type=script&lang=ts"
import style0 from "./UgTabItem.vue?vue&type=style&index=0&id=e1fc3eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fc3eaa",
  null
  
)

export default component.exports